import { rem } from "../../framework/theme/util/misc.js";
import { BaseCard } from "./BaseCard.js";
import { CardHeader } from "./internal/CardHeader.js";
import { jsx } from "react/jsx-runtime";

//#region src/components/card/FilledCard.tsx
const InnerFilledCard = ({ children, footer, header, Icon, color = "primary", withBorder = false, onClick, role, "data-testid": testId, withOutline = false, sharp = false, fullWidthFooter = false, pinFooter, fullHeight }) => {
	const Header = header ? /* @__PURE__ */ jsx(CardHeader, { children: header }) : null;
	return /* @__PURE__ */ jsx(BaseCard, {
		onClick,
		role,
		withBorder,
		bg: `var(--mantine-color-${color}-0)`,
		footer,
		fullWidthFooter,
		pinFooter,
		fullHeight,
		header: Header,
		Icon,
		iconColor: color,
		variant: "filled",
		padding: "sm",
		radius: sharp ? "0" : "sm",
		style: {
			borderColor: "var(--card-border-color)",
			outline: "var(--card-outline-size) solid var(--card-border-color)"
		},
		__vars: {
			"--card-border-color": `var(--mantine-color-${color}-7)`,
			"--card-outline-size": withOutline ? rem("1px") : "0"
		},
		"data-testid": testId,
		children
	});
};
const FilledCard = ({ children, footer, header, Icon, color = "primary", withBorder = false, onClick, role, "data-testid": testId, sharp = false, fullWidthFooter = false, pinFooter = false }) => {
	return /* @__PURE__ */ jsx(InnerFilledCard, {
		color,
		withBorder,
		header,
		footer,
		fullWidthFooter,
		pinFooter,
		Icon,
		onClick,
		role,
		"data-testid": testId,
		sharp,
		children
	});
};

//#endregion
export { FilledCard, InnerFilledCard };